import React from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const LottieLoad = ({ url }) => {
    return (
        <div style={{ width: '200px', height: '500px' }}> {/* Adjust size here */}
            <DotLottieReact
                src={url}
                loop
                autoplay
                rendererSettings={{
                    preserveAspectRatio: 'xMidYMid slice', // Helps with scaling the animation
                    quality: 'high', // Ensure high-quality rendering
                }}
                width="100%" // Make it responsive
                height="100%" // Make it responsive
            />
        </div>
    );
};

export default LottieLoad;
